import React from "react";
import { Link } from "react-router-dom";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

// ✅ helper to limit words and add "..."
const limitWords = (text = "", maxWords = 25) => {
  const words = text.trim().split(/\s+/);
  if (words.length <= maxWords) return text;
  return words.slice(0, maxWords).join(" ") + "...";
};

const ProjectCard = ({ project }) => {
  const projectId = project.project_id || project.id;
  const name = project.project_name || "";
  const description = project.project_description || "";
  const badgeLocation = project.project_badge_location || "";
  const type = project.project_type || "";
  const price = project.project_price || "";
  // ✅ apply word limit here
  const features = limitWords(project.features || "", 25);

  const getImageUrl = () => {
    if (project.project_image) return project.project_image;
    if (project.image) return project.image;
    if (project.image_url) {
      const baseUrl = API_BASE_URL?.replace("/api", "") || "";
      return `${baseUrl}${project.image_url}`;
    }
    return " ";
  };

  const image = getImageUrl();


const slugify = (text = "") =>
  text
    .toLowerCase()
    .trim()
    .replace(/[^\w\s-]/g, "")
    .replace(/\s+/g, "-");

  return (
    <div className="group bg-white rounded-3xl shadow-xl hover:shadow-2xl transition-all duration-500 border border-gray-100 flex flex-col overflow-hidden hover:-translate-y-2 hover:border-green-200 w-full max-w-xs sm:max-w-sm md:max-w-md lg:max-w-lg mx-auto my-4 sm:my-5 md:my-6">
      {/* Image */}
      <div className="relative w-full h-60 overflow-hidden rounded-t-xl">
        <img
          src={image}
          alt={name}
          className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
        />
      </div>

      {/* Content */}
      <div className="p-4 sm:p-5 md:p-7 flex flex-col flex-1">
        {/* Title + Location */}
        <h3 className="text-base sm:text-lg md:text-xl font-bold text-gray-900 mb-1 line-clamp-2">
          {name}
        </h3>

        {badgeLocation && (
          <p className="text-gray-500 text-xs sm:text-sm mb-3 truncate">
            {badgeLocation}
          </p>
        )}

        {/* Description */}
        {description && (
          <p className="text-gray-600 text-xs sm:text-sm leading-relaxed mb-4 line-clamp-3 text-justify">
            {description}
          </p>
        )}

        {/* Type & Price */}
        <div className="grid grid-cols-2 gap-3 mb-4">
          <div className="bg-blue-50 border border-blue-100 rounded-lg p-2.5 sm:p-3 text-center">
            <p className="text-gray-500 text-[10px] sm:text-xs font-medium mb-1">
              Type
            </p>
            <p className="text-gray-800 font-semibold text-xs sm:text-sm md:text-base break-words">
              {type}
            </p>
          </div>

          <div className="bg-green-50 border border-green-100 rounded-lg p-2.5 sm:p-3 text-center">
            <p className="text-gray-500 text-[10px] sm:text-xs font-medium mb-1">
              Project Status
            </p>
            <p className="text-gray-800 font-semibold text-xs sm:text-sm md:text-base break-words">
              {price}
            </p>
          </div>
        </div>

        {/* Features */}
        {features && (
          <div className="bg-green-50 border border-green-100 rounded-lg p-3 sm:p-4 mb-4">
            <p className="text-green-700 font-semibold text-xs sm:text-sm mb-1">
              Key Features
            </p>
            <p className="text-gray-700 text-xs sm:text-sm leading-relaxed line-clamp-2 text-justify">
              {features}
            </p>
          </div>
        )}

        {/* CTA */}
        {projectId ? (
          <Link
          to={`/projects/${slugify(name)}`}
            className="mt-auto w-full bg-green-600 hover:bg-green-700 text-white font-semibold py-2 sm:py-2.5 md:py-3 rounded-xl text-center text-sm sm:text-base transition-all duration-300"
          >
            More Details
          </Link>
        ) : (
          <button
            disabled
            className="mt-auto w-full bg-gray-400 text-white font-semibold py-2 sm:py-2.5 md:py-3 rounded-xl text-center text-sm sm:text-base cursor-not-allowed"
          >
            Details Unavailable
          </button>
        )}
      </div>
    </div>
  );
};

export default ProjectCard;
